import styled from '@emotion/styled';
import { IPublicCompany } from 'domain/entities/Company/Company';
import { CompanyCard } from 'ui/components/company/features/CompanyCard';
import 'dayjs/locale/ja';

interface Props {
    companies: IPublicCompany[];
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 40px;
`;

const Title = styled.h1`
    font-weight: 700;
    font-size: 18px;
`;

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    margin: 10px auto;
    width: calc(100% - 40px);
    gap: 30px;
`;

export const TopOfferSellers: React.FC<Props> = ({ companies }) => {
    return (
        <Wrapper id="top-offer-sellers">
            <Title>オファーが多い登録企業</Title>
            {companies.length === 0 && (
                <div style={{ marginTop: '10px', paddingLeft: '20px', textAlign: 'left' }}>
                    現在似た業種、売上規模の売り手企業の企業の登録はありません。
                </div>
            )}
            <Container>
                {companies.map((company) => (
                    <CompanyCard company={company} />
                ))}
            </Container>
        </Wrapper>
    );
};
